/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Bright_Bee_SingInputs */

const en_light_bright_bee_sing = /** @type {(inputs: Light_Bright_Bee_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select language...`)
};

const de_light_bright_bee_sing = /** @type {(inputs: Light_Bright_Bee_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache auswählen...`)
};

/**
* | output |
* | --- |
* | "Select language..." |
*
* @param {Light_Bright_Bee_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_bright_bee_sing = /** @type {((inputs?: Light_Bright_Bee_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Bright_Bee_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_bright_bee_sing(inputs)
	return de_light_bright_bee_sing(inputs)
});